import cn from "classnames";

import stylesPromoCode from "../../cart/cart-promo-code.module.scss";
import styles from "./skeleton-cart-promo-code.module.scss";

export default function SkeletonCartPromoCode() {
  return (
    <div className={cn(stylesPromoCode.container, styles.container, "pulseAnimation")}>
      <div className={cn(stylesPromoCode.button)}>
        <p className={cn(styles.button, styles.backgroundLightGray)}></p>
        <span className={cn(styles.arrow, styles.backgroundLightGray)}></span>
      </div>
    </div>
  );
}
